import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/about.png";
import Toolstack from "./Toolstack";
import AiTools from "./AiTools";
import "./About.css";

function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        <Row className="about-intro-row">
          <Col md={7} className="about-intro-col">
            <h1 className="about-heading">
              What <strong className="purple">I do</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col md={5} className="about-img-col about-img">
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <h1 className="project-heading">
          Professional <strong className="purple">Skillset </strong>
        </h1>

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Tools</strong> I use
        </h1>
        <Toolstack />

        <h1 className="project-heading">
          <strong className="purple">AI</strong> tools I use
        </h1>
        <AiTools />
      </Container>
    </Container>
  );
}

export default About;
